(function () {
  var root = document.documentElement;
  if (root.classList.contains('zl-anim-ready')) return;
  root.classList.add('zl-anim-ready');

  /* Mobile product carousel: dots follow the scroll position and jump on tap */
  function initCarousels() {
    document.querySelectorAll('[data-zl-dots]').forEach(function (nav) {
      var track = document.getElementById(nav.getAttribute('data-zl-dots'));
      if (!track || track.dataset.zlBound) return;
      track.dataset.zlBound = '1';
      var dots = nav.querySelectorAll('.zl-dot');
      var cards = track.children;
      var set = function (i) {
        dots.forEach(function (d, j) {
          d.classList.toggle('is-active', i === j);
          if (i === j) d.setAttribute('aria-current', 'true'); else d.removeAttribute('aria-current');
        });
      };
      dots.forEach(function (d, i) {
        d.addEventListener('click', function () {
          if (cards[i]) track.scrollTo({ left: cards[i].offsetLeft - track.offsetLeft - parseFloat(getComputedStyle(track).scrollPaddingLeft || 0), behavior: 'smooth' });
        });
      });
      var ticking = false;
      track.addEventListener('scroll', function () {
        if (ticking) return;
        ticking = true;
        requestAnimationFrame(function () {
          ticking = false;
          var x = track.scrollLeft, best = 0, dist = Infinity;
          for (var i = 0; i < cards.length; i++) {
            var dd = Math.abs(cards[i].offsetLeft - track.offsetLeft - x);
            if (dd < dist) { dist = dd; best = i; }
          }
          if (x + track.clientWidth >= track.scrollWidth - 4) best = cards.length - 1;
          set(best);
        });
      }, { passive: true });
    });
  }

  /* Scroll reveal */
  function initReveal() {
    if (window.Shopify && Shopify.designMode) return;
    if (!('IntersectionObserver' in window)) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    document.querySelectorAll('.zl [data-zl-reveal]').forEach(function (el) {
      var r = el.getBoundingClientRect();
      if (r.top < window.innerHeight * 0.92) { el.classList.add('is-in'); } else { io.observe(el); }
    });
    document.querySelectorAll('.zl').forEach(function (s) { s.classList.add('zl-anim'); });
  }

  /* Shop page: compare two formulas, picked from the column dropdowns */
  function initCompare() {
    document.querySelectorAll('[data-zl-cmp]').forEach(function (cmp) {
      if (cmp.dataset.zlBound) return;
      cmp.dataset.zlBound = '1';
      var sels = [cmp.querySelector('[data-cmp-select="1"]'), cmp.querySelector('[data-cmp-select="2"]')];
      if (!sels[0] || !sels[1]) return;
      var prev = [sels[0].value, sels[1].value];
      var apply = function () {
        var a = sels[0].value, b = sels[1].value;
        cmp.querySelectorAll('[data-col]').forEach(function (c) {
          var k = c.getAttribute('data-col');
          c.hidden = k !== a && k !== b;
          c.style.order = k === a ? 1 : 2;
        });
        prev = [a, b];
      };
      sels.forEach(function (sel, i) {
        sel.addEventListener('change', function () {
          var other = sels[1 - i];
          if (sel.value === other.value) other.value = prev[i];
          apply();
        });
      });
      apply();
    });
  }

  function init() { initCarousels(); initCompare(); initReveal(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', function () { initCarousels(); initCompare(); });
})();
